import React from 'react';

export default function MercuryLogo() {
  return (
    <div className="flex items-center gap-2.5">
      <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19" cy="19" r="18" fill="#0b0f0d" />
        <text x="19" y="24" textAnchor="middle" fill="#faf9f5" style={{ font: '600 13px Fraunces, Georgia, serif', letterSpacing: '0.02em' }}>THL</text>
        <circle cx="30" cy="9" r="2.6" fill="#ea580c" />
      </svg>
      <div className="leading-none">
        <div className="font-display font-semibold text-[#0b0f0d] text-[16px] tracking-tight">Trusted Home</div>
        <div className="text-[10px] font-semibold text-[#8a8a80] tracking-[0.32em] mt-1 uppercase">Leads</div>
      </div>
    </div>
  );
}
